import { Badge } from 'react-bootstrap';
import { I18n } from '@/i18n/I18n';
import { ReportVerdict } from '@/reports/types';

export function verdictVariant(verdict: ReportVerdict): string {
  return verdict === 'passed' ? 'success' : verdict === 'failed' ? 'danger' : 'warning';
}

/** A report's verdict, worded as the report words it. */
export function VerdictBadge({ verdict, label }: { verdict: ReportVerdict; label: string }) {
  return <Badge bg={verdictVariant(verdict)} text={verdict === 'incomplete' ? 'dark' : undefined} aria-label={I18n.get(`verdict_${verdict}`)}>{label}</Badge>;
}

export function runStatusVariant(status: string): string {
  return status === 'PASSED' ? 'success' : status === 'FAILED' ? 'danger' : 'secondary';
}
